import { Component, OnInit, Input} from "@angular/core";

@Component({
  selector: "ngx-loader",
  templateUrl:  './ngx-loaded.html'
})
export class Loader implements OnInit{
    @Input() public loading = false;
    ngOnInit(){}
}